import React, { useState, useEffect } from "react"

import GetTimeStamp from './GetTimeStamp';


const GetICM = function () {
    const [diagramUrl, setUrl] = useState();

    useEffect(() => {
    //    GetTimeStamp()
            // .then(data =>
            //     icmDiagram(data)
            // );
    }, []);


    const icmDiagram = (time) => {
        console.log("dadsa", time)
        let tmp = time
        tmp = tmp.substring(0, tmp.length - 3);
        tmp = tmp.replace(/-+/g, '');
        tmp = tmp.replace(/\s/g, '');
        console.log(tmp)


        setUrl(`https://www.meteo.pl/um/metco/mgram_pict.php?ntype=0u&amp;fdate=${tmp}&amp;row=390&amp;col=203&amp;lang=pl`);



    }


    console.log(diagramUrl)



    // tafDiv = tafDiv.replace(/<[^>]*>?/gm, ''); //remove html tags
    // tafDiv = tafDiv.replace(/\s+/g, ' ').trim(); // remove duplicated space

    // let tafsArray = tafDiv.split("=");
    // tafsArray.pop();
    // tafsArray = tafsArray.map(i => i = i + "=");
    // // console.log("tafsArray ", tafsArray)

    // if (typeof icao !== 'undefined' && icao.length > 0) {
    //     var PATTERN = new RegExp(icao, "g");
    //     const filtered = tafsArray.filter(function (str) { return PATTERN.test(str); });
    //     console.log("filtred by:", icao, filtered); // [{name: 'Lea', country: 'Italy'}]

    //     if (typeof filtered !== 'undefined' && filtered.length > 0) {
    //         setTAFs(filtered);
    //     } else {
    //         let res = `Brak depesz TAF dla ${icao}`;
    //         setTAFs(res);
    //     }
    // }


    return 
    (
        <>
            {/* <div className='home__hero-subtitle'>
                DIAGRAM ICM
                {GetTimeStamp()}
                <a
                    href="https://m.meteo.pl/inowroclaw/60"
                    target="_blank"
                    title="EPIR ICM Meteo"
                    rel="noreferrer">
                    <img


                        src={diagramUrl}
                        // src="https://www.meteo.pl/um/metco/mgram_pict.php?ntype=0u&amp;fdate=2022020212&amp;row=390&amp;col=203&amp;lang=pl"
                        alt="Błąd podczas wczytywania diagramu ICM dla EPIR"

                    />
                </a>

            </div> */}
        </>
    )
}

export default GetICM